export default class CompletedModel {
    public completed: boolean = false;
    public percentage: number;

    constructor(percentage: number) {
        this.percentage = percentage;
    }

}
